export default __webpack_public_path__ + "563cebe1104db7409f01cf2cc8a59c5f.png";